import isString from "lodash/isString";
import includes from "lodash/includes";

import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/it";
import "moment/locale/ja";
import "moment/locale/ko";
import "moment/locale/nl";
import "moment/locale/pl";
import "moment/locale/pt";
import "moment/locale/ru";
import "moment/locale/tr";
import "moment/locale/zh-cn";
import "moment/locale/bg";
import "moment/locale/cs";
import "moment/locale/da";
import "moment/locale/el";
import "moment/locale/fi";
import "moment/locale/hu";
import "moment/locale/ro";
import "moment/locale/sv";
import "moment/locale/th";
import "moment/locale/az";
import "moment/locale/br";

import LOCALES from "../constants/SupportedLocales";
import i18next from "./i18next";

function cleanRegion(locale) {
    return locale.indexOf("-") >= 0 ? locale.split("-")[0] : locale;
}

export function t(key, options) {
    return options ? i18next.t(key, options) : i18next.t(key);
}

export function getLocale(companySupportedLocales, currentLocale) {
    if (currentLocale && !isString(currentLocale)) {
        throw new TypeError("DirectlyRTM lang expects a string.");
    } else if (currentLocale && !includes(LOCALES, currentLocale)) {
        throw new Error(`${currentLocale} is not a supported language. Please use ${LOCALES.toString()}`);
    }

    let locale = currentLocale || i18next.language;
    locale = cleanRegion(locale);

    return includes(companySupportedLocales, locale) && includes(LOCALES, locale) ? locale : "en";
}
